(function () {
  module.exports = {
    toArabic: require('./lib/toArabic.js'),
    toRoman:require('./lib/toRoman.js')
  };
})();



//////////////////
// WEBPACK FOOTER
// ./~/roman-numerals/index.js
// module id = 432
// module chunks = 0